var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgRatingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.74 13.57L23.08 19.11C22.95 19.22 22.89 19.39 22.92 19.56L24.91 28.7C24.97 28.96 24.87 29.21 24.65 29.37C24.43 29.53 24.16 29.54 23.93 29.4L16.22 24.77C16.15 24.73 16.07 24.7 15.98 24.7C15.9 24.7 15.82 24.72 15.74 24.77L8.06001 29.4C7.83001 29.54 7.56001 29.53 7.34001 29.37C7.12001 29.21 7.03001 28.96 7.08001 28.7L9.07001 19.56C9.11001 19.39 9.05001 19.22 8.91001 19.11L2.25001 13.57C2.04001 13.4 1.96001 13.14 2.04001 12.88C2.12001 12.62 2.32001 12.45 2.59001 12.42L11 11.46C11.16 11.44 11.29 11.35 11.36 11.2L15.4 2.87C15.51 2.64 15.73 2.5 15.99 2.5C16.25 2.5 16.47 2.64 16.58 2.87L20.62 11.2C20.69 11.34 20.82 11.44 20.98 11.46L29.39 12.42C29.66 12.45 29.86 12.62 29.94 12.88C30.03 13.14 29.95 13.4 29.74 13.57Z",
    fill: "#FF8500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgRatingIcon);
export default __webpack_public_path__ + "static/media/beemg-rating-icon.478f1e7e897a4a9cd74e27e877a69a0d.svg";
export { ForwardRef as ReactComponent };